import React from "react";
import PropTypes from "prop-types";
import Badge from "antd/es/badge";
import Card from "antd/es/card";
import Col from "antd/es/col";
import Row from "antd/es/row";

const NotesInformation = ({ transactionRecord }) => (
  <Card style={{ marginTop: "20px", borderColor: "#ffb551" }}>
    <Row type="flex" justify="space-between">
      <Col style={{ paddingTop: "5px" }}>
        <Badge count={"Notes"} className="details-badge" />
      </Col>
    </Row>

    <div className="left-margin">
      <Row>
        <span className="notes-info">
          {transactionRecord.operationData[0].notes
            ? transactionRecord.operationData[0].notes
            : "-"}
        </span>
      </Row>
    </div>
  </Card>
);

NotesInformation.propTypes = {
  transactionRecord: PropTypes.object.isRequired,
};

export default NotesInformation;
